import type { CodeFormValue } from './types';

import { CodeError } from 'app/api/services/client/user-contacts-setting/constants';
import type { tFunction } from 'app/lang';

import dictionary from './CodeConfirmation.dictionary.json';

export const CODE_FORM_VALUES: CodeFormValue = {
  code: '',
};

export const FIELD_NAME = 'code';
export const CODE_LENGTH = 4;

export const getBodyText = (t:tFunction, requisite: string) => {
  return {
    phone: {
      title: t(dictionary.phoneTitle, { requisite }),
      change: t(dictionary.phoneChange),
    },
    prompt: t(dictionary.prompt),
    error: t(dictionary.error),
  };
};

export { CodeError };
